// 最简单的 admin 鉴权状态：localStorage token + 轻量订阅。
// 不引 zustand / redux —— 状态就两个：token 在 / token 不在。

import { setToken } from '../api/client';

const TOKEN_KEY = 'jiali.admin.token';
const USER_KEY = 'jiali.admin.userId';

type Listener = () => void;
const listeners = new Set<Listener>();

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}

export function getUserId(): string | null {
  return localStorage.getItem(USER_KEY);
}

export function isLoggedIn(): boolean {
  return !!getToken();
}

export function login(token: string, userId: string) {
  setToken(token);
  localStorage.setItem(USER_KEY, userId);
  listeners.forEach((l) => l());
}

export function logout() {
  setToken(null);
  localStorage.removeItem(USER_KEY);
  listeners.forEach((l) => l());
}

export function subscribe(l: Listener): () => void {
  listeners.add(l);
  return () => listeners.delete(l);
}
